import { useEffect, useState } from "react";
import styleSheet from "../style.module.scss";
import SyIcon from "../../../../../shared/components/sy-icon";
const AdminPagination = (props: any) => {
  const { adminListData, pageIndex, pageSize, updateAdminList } = props;
  const [filterId, setFilterId] = useState<any>(null);
  const [showPreIcon, setShowPreIcon] = useState<any>(true);
  const [showNextIcon, setShowNextIcon] = useState<any>(true);

  const onFilterClick = (id: any) => {
    if (id === filterId) {
      setFilterId(null);
      updateAdminList("planet", null);
    } else {
      updateAdminList("planet", id);
      setFilterId(id);
    }
  };

  const onNavClick = (nav: any) => {
    setFilterId(null);
    updateAdminList("nav", nav);
  };
  useEffect(() => {
    setNavButton(adminListData.allPlanets);
  }, [adminListData]);

  const setNavButton = (listHeader: any) => {
    const maxIndex = Math.ceil(listHeader?.total / pageSize) - 1;
    if (listHeader?.total > pageSize) {
      if (pageIndex === 0) {
        setShowPreIcon(false);
        setShowNextIcon(true);
      } else {
        setShowPreIcon(true);
      }
      if (maxIndex == pageIndex) {
        setShowNextIcon(false);
      }
    } else {
      setShowPreIcon(false);
      setShowNextIcon(false);
    }
  };

  return (
    <>
      <div
        className={`d-flex py-5 justify-content-center ${styleSheet.paginatior}`}
      >
        <div className="d-flex align-items-center me-2">
          {showPreIcon && (
            <SyIcon
              name={"arrow_back_ios"}
              iconColor={"white"}
              className={` opacity-75 pointer  `}
              onClick={() => onNavClick("pre")}
            />
          )}
        </div>
        <div className=" sy-scroll-y sy-scroll-x d-flex pt-4 ">
          {adminListData?.allPlanets?.planets.map((data: any) => {
            const isSelected = filterId === data.pro_id;
            return (
              <div
                key={data.pro_id}
                // className={`${
                //   isSelected
                //     ? `${styleSheet.selected_filter} `
                //     : `${styleSheet.filter_wrapper} opacity-25`
                // }  px-4 pointer `}
                className={`
                 px-1 `}
              >
                <div
                  className={`${
                    isSelected
                      ? `${styleSheet.selected_filter} `
                      : `${styleSheet.filter_wrapper} opacity-25`
                  } pointer`}
                >
                  <div className="d-flex justify-content-center  ">
                    <img
                      src={data.category_image_url}
                      onClick={() => onFilterClick(data.pro_id)}
                      className={`${styleSheet.filter_img} `}
                    />
                    {data.unseen_noti ?(
                    <SyIcon
                      name={"mark_email_unread"}
                      iconColor={"white"}
                      className={` opacity-75 pointer font-12  `}
                    />):null}
                  </div>

                  <div className="d-flex justify-content-center  ">
                    <p
                      className={`${styleSheet.filter_name} mb-0 text-white mohave ellipsis text-center`}
                    >
                      {data.pro_name}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex align-items-center me-2">
          {showNextIcon && (
            <SyIcon
              name={"arrow_back_ios"}
              iconColor={"white"}
              className={`opacity-75 pointer ${styleSheet.filter_rotate_icon}`}
              onClick={() => onNavClick("next")}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AdminPagination;
